import { type Ripple } from "@dashboard/ripples/types";

export const rippleProductMetadata: Ripple = {
  type: "improvement",
  ID: "product-metadata-header",
  TTL_seconds: 60 * 60 * 24 * 7,
  dateAdded: new Date(2026, 4, 31),
  content: {
    oneLiner: "Product metadata in header",
    contextual: "제품 메타데이터를 수정할 수 있습니다.",
    global:
      "제품 메타데이터가 제품 페이지의 하단에서 헤더 버튼으로 이동했습니다. 공개 및 비공개 메타데이터를 쉽게 찾고 수정할 수 있습니다.",
  },
};
